import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { useSnackbar, WithSnackbarProps } from "notistack";
import {
  IGroups,
  IParticipants,
  IServicesDevice,
  IParticipantsList,
  IDevicesList,
  IEmailList,
  IGroupList,
  ICurrentDeallocateDevice,
} from "src/models/infrastructure";
import jwt_decode from "jwt-decode";
import { reducer as vdiserviceslice } from "src/slices/vdiserviceTable";
import { storeCurrentGroupID } from "../waitingAV";
import Permission from "src/permision.json";
import { editorActions, removePresenterAccess, removePresenterAccessUpdate, setSnakMsg } from "src/slices/editor";
import { FailureSnackbar } from "../snackbar";
let useSnackbarRef: WithSnackbarProps;
export const SnackbarUtilsConfigurator: React.FC = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

enum ECOLOR {
  INFO = "info",
  ERROR = "error",
  SUCCESS = "success",
}

interface IAssignedMachineData {
  process: string;
  serviceId: string;
  type: string;
}

interface IApplication {
  id: string;
  itemName: string;
  path: string;
}

interface IResourceAssignment {
  groups: {
    [key: string]: IGroups;
  };
  participants: IParticipants[];
  filterParticipants: IParticipants[];
  currentDeallocateDevice: ICurrentDeallocateDevice[];
  userTablePage: number;
  participantsList: IParticipantsList[];
  devicesList: IDevicesList[];
  servicesDevice: IServicesDevice[];
  UnassignServices: IServicesDevice[];
  destroyedSerivices: IServicesDevice[];
  assignServices: IServicesDevice[];
  allServices: IServicesDevice[];
  toggleDrawer: boolean;
  AllocateDialog: boolean;
  serviceUpdate: {
    [key: string]: any;
  };
  filterValue: {
    type: string;
    value: string[];
  }[];
  filterNames: {
    id: string;
    lable: string;
  }[];
  filterValueTable: {
    type: string;
    value: string[] | string | boolean;
  }[];
  filterNamesTable: {
    id: string;
    lable: string;
  }[];
  participantsName: string[];
  emailList: IEmailList[];
  groupList: IGroupList[];
  servicesId: string;
  participantId: string;
  action: string;
  deviceId: string;
  PtoSActive: boolean;
  StoPActive: boolean;
  snack: {
    active: boolean;
    color: ECOLOR;
    message: string;
  };
  instanceFilter: string;
  VDIOption: {
    active: boolean;
    message: string;
    color: string;
  };
  currentPageNumber: number;
  promptData: {
    active: boolean;
    body?: {
      device: string;
      participant_id: string;
      access: string;
    };
    groupId?: string;
  };
  participantsData: IParticipants[];
  locked: boolean;
  lockedMsg: string;
  updateGroupNotify: {
    active: boolean;
    message: string;
  };
  UnassignServicesAllVDI: IServicesDevice[];
  ConfirmDestroy: {
    confirmMessage: string;
    userConfirmation: string;
  };
  OperationMachine: ICurrentDeallocateDevice[];
  currentTabOpened: boolean;
  assignedMachineData: IAssignedMachineData[];
  isShowBulkDestroyActiveMachine: boolean;
  showMaxLimitDisclaimer: boolean;
  disclaimerType?: "limit" | "credits";
  maxLimitMessage?: string;
  limitIntent?: string;
  deviceAssignLoader: boolean;
  machineArchival?: {
    serviceId?: string;
    openModal?: boolean;
    groupId?: string;
    planId?: string;
    contextId?: string;
    archiving?: boolean;
    planLoader?: boolean;
    archivalCostPerHour?: number;
    monthlyHours?: number;
  };
  liveParticipants: IParticipants[];
  loadingApplications: boolean;
  groupApplications: IApplication[];
  selectedApplications: IApplication[];
}

const initialState: IResourceAssignment = {
  groups: {},
  participants: [],
  filterParticipants: [],
  currentDeallocateDevice: [],
  userTablePage: 0,
  servicesDevice: [],
  UnassignServices: [],
  destroyedSerivices: [],
  assignServices: [],
  allServices: [],
  participantsList: [],
  devicesList: [],
  toggleDrawer: false,
  AllocateDialog: false,
  filterValue: [],
  filterNames: [],
  filterValueTable: [],
  filterNamesTable: [],
  participantsName: [],
  emailList: [],
  groupList: [],
  servicesId: "",
  participantId: "",
  action: "",
  deviceId: "",
  PtoSActive: false,
  StoPActive: false,
  snack: {
    active: false,
    color: ECOLOR.INFO,
    message: "",
  },
  serviceUpdate: {},
  instanceFilter: "Unassigned",
  VDIOption: {
    active: false,
    message: "",
    color: "",
  },
  currentPageNumber: 1,
  promptData: {
    active: false,
  },
  participantsData: [],
  locked: false,
  lockedMsg: "",
  updateGroupNotify: {
    active: false,
    message: "",
  },
  UnassignServicesAllVDI: [],
  ConfirmDestroy: {
    confirmMessage: "CONFIRM",
    userConfirmation: "",
  },
  OperationMachine: [],
  currentTabOpened: false,
  assignedMachineData: [],
  isShowBulkDestroyActiveMachine: false,
  showMaxLimitDisclaimer: false,
  disclaimerType: "limit",
  maxLimitMessage: "",
  limitIntent: "",
  deviceAssignLoader: false,
  machineArchival: {
    serviceId: "",
    openModal: false,
    groupId: "",
    planId: "",
    contextId: "",
    archiving: false,
    planLoader: false,
    archivalCostPerHour: 0.0000,
    monthlyHours: 0,
  },
  liveParticipants: [],
  loadingApplications: false,
  groupApplications: [],
  selectedApplications: [],
};

const ResourceAllocationSlice = createSlice({
  name: "vdiservice",
  initialState,
  reducers: {
    participants(state, action) {
      state.participants = action.payload;
      state.filterParticipants = action.payload;
      const arrayName = [];
      const arrayEmail = [];
      action.payload.forEach((value) => {
        arrayName.push({ id: value.id, name: value.name });
        arrayEmail.push({ id: value.id, name: value.emailId });
      });

      state.participantsList = arrayName;
      state.emailList = arrayEmail;
    },
    setUpdateFilterParticipants(state, action) {
      state.filterParticipants = action.payload;
    },
    setUserTablePage(state, action) {
      state.userTablePage = action.payload;
    },
    availableGroups(state, action) {
      const arrayGroup = [];
      if (action.payload?.length > 0) {
        action.payload.forEach((value) => {
          arrayGroup.push({ id: value.id, name: value.name });
        });

        state.groupList = arrayGroup;
        const arrayToObject = (arr, key) => {
          return arr.reduce((obj, item) => {
            obj[item[key]] = item;
            return obj;
          }, {});
        };
        state.groups = arrayToObject(action.payload, "id");
      }
    },
    updateServiceName(state, action) {
      const { id, name } = action.payload;
      if (state.servicesDevice) {
        state.servicesDevice = state.servicesDevice.map((s) =>
          s.id === id ? { ...s, name } : s
        );
      }
      if (state.allServices) {
        state.allServices = state.allServices.map((s) =>
          s.id === id ? { ...s, name } : s
        );
      }
      if (state.UnassignServices) {
        state.UnassignServices = state.UnassignServices.map((s) =>
          s.id === id ? { ...s, name } : s
        );
      }
      if (state.assignServices) {
        state.assignServices = state.assignServices.map((s) =>
          s.id === id ? { ...s, name } : s
        );
      }
    },
    availableservices(state, action) {
      if (action.payload) {
        state.allServices = action.payload;
        state.serviceUpdate = action.payload.reduce((acc, cur) => {
          acc[cur["id"]] = cur.state;
          return acc;
        }, {});
        state.UnassignServicesAllVDI = action.payload.filter(
          (value) => !value.access.find((a) => a.access !== "host"),
        );
      } else {
        state.allServices = [];
      }
    },
    toggleDrawer(state, action) {
      state.toggleDrawer = action.payload;
    },
    AllocateDialog(state, action) {
      state.AllocateDialog = action.payload;
    },
    storeServiceDevice(state, action) {
      state.servicesDevice = action.payload;
      state.UnassignServices = action.payload?.filter(
        (value) =>
          !value.access.find((a) => a.access !== "host") &&
          value.state !== "DESTROYED",
      );
      state.assignServices = action.payload?.filter((value) =>
        value.access.find((a) => a.access !== "host"),
      );
      state.destroyedSerivices = action.payload.filter(
        (value) => value.state === "DESTROYED" || value.state === "DESTROYING",
      );
    },
    storeFilterValue(state, action) {
      state.filterValue = action.payload;
    },
    storeFilterNames(state, action) {
      state.filterNames = action.payload;
    },
    storeFilterValueTable(state, action) {
      state.filterValueTable = action.payload;
    },
    storeFilterNamesTable(state, action) {
      state.filterNamesTable = action.payload;
    },
    storeFilterServiceDevices(state, action) {
      const array = [];
      action.payload?.forEach((value) => {
        if (value.state !== "REGISTERED") {
          array.push({ id: value.id, name: value.name });
        }
      });

      state.devicesList = array;
    },
    setParticiapntId(state, action) {
      state.participantId = action.payload;
    },
    setServiceId(state, action) {
      state.servicesId = action.payload;
    },
    setAction(state, action) {
      state.action = action.payload;
    },
    setDeviceId(state, action) {
      state.deviceId = action.payload;
    },
    setPtoSActive(state, action) {
      state.PtoSActive = action.payload;
    },
    setStoPActive(state, action) {
      state.StoPActive = action.payload;
    },
    setSnack(state, action) {
      state.snack = action.payload;
    },
    setServiceUpdate(state, action) {
      state.serviceUpdate[action.payload.key] = action.payload.value;
    },
    setParticipantsUpdate(state, action) {
      state.participants.forEach((value) => {
        if (value.id === action.payload.key) {
          value.lock = action.payload.value;
        }
      });
      state.participantsData.forEach((value) => {
        if (value.id === action.payload.key) {
          value.lock = action.payload.value;
        }
      });
    },
    setFilterValue(state, action) {
      state.instanceFilter = action.payload;
    },
    VDIOptions(state, action) {
      state.VDIOption = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPageNumber = action.payload;
    },
    setPropmtData(state, action) {
      state.promptData = action.payload;
    },
    setParticipantData(state, action) {
      state.participantsData = action.payload;
    },
    setLocked(state, action) {
      state.locked = action.payload;
    },
    setLockedMsg(state, action) {
      state.lockedMsg = action.payload;
    },
    setUpdateGroupSnack(state, action) {
      state.updateGroupNotify = action.payload;
    },
    setDeallocateAll(state, action) {
      state.currentDeallocateDevice = action.payload;
    },
    setDestroyMessage(state, action) {
      state.ConfirmDestroy[action.payload.key] = action.payload.value;
    },
    setDestroyMessageClear(state) {
      state.ConfirmDestroy.userConfirmation = "";
    },
    setOperationMachine(state, action) {
      state.OperationMachine = action.payload;
    },
    setOperationMachineClear(state) {
      state.OperationMachine = [];
    },
    setSortingParticipants(state, action) {
      state.participants = action.payload;
    },
    setCurrentTabOpened(state, action) {
      state.currentTabOpened = action.payload;
    },
    assignedMachineData(state, action) {
      state.assignedMachineData = action.payload;
    },
    showBulkDestroyActiveMachine(state, action) {
      state.isShowBulkDestroyActiveMachine = action.payload;
    },
    handleShowMaxLimitDisclaimer(state, action) {
      state.showMaxLimitDisclaimer = action.payload;
    },
    setDeviceAssignLoader(state, action) {
      state.deviceAssignLoader = action.payload;
    },
    disclaimerType(state, action) {
      state.disclaimerType = action.payload;
    },
    maxLimitMessage(state, action) {
      state.maxLimitMessage = action.payload;
    },
    limitIntent(state, action) {
      state.limitIntent = action.payload;
    },
    machineArchival(state, action) {
      state.machineArchival[action.payload.key] = action.payload.value;
    },
    machineArchivalData(state, action) {
      state.machineArchival = action.payload;
    },
    resetMachineArchivalData(state) {
      state.machineArchival = initialState?.machineArchival;
    },
    setLiveParticipants(state, action) {
      state.liveParticipants = action.payload;
    },
    setSpeakingStatus(state, action) {
      state.participants = state.participants.map((item) => {
        if (item.id === action.payload.participant_id && action.payload.type === "start") {
          return { ...item, isSpeaking: true, isMicOn: true, raiseHandStatus: false };
        }
         if (item.id === action.payload.participant_id && action.payload.type === "end") {
          return { ...item, isSpeaking: false, isMicOn: false, raiseHandStatus: false };
        }
        return item;
      });
    },
    setTrainerSpeakingStatus(state, action) {
      state.participants = state.participants.map((item) => {
        if (item.id === action.payload.participant_id && action.payload.type === "start") {
          return { ...item, isSpeaking: true, isMicOn: true, raiseHandStatus: false };
        }
        if (item.id === action.payload.participant_id && action.payload.type === "pause") {
          return { ...item, isSpeaking: false, isMicOn: false, raiseHandStatus: false };
        }
        return item;
      });
    },
    setApplicationsLoading(state, action) {
      state.loadingApplications = action.payload;
    },
    applicationsData(state, action) {
      state.groupApplications = action.payload;
    },
    selectedApplications(state, action) {
      state.selectedApplications = action.payload;
    },
    addApplication(state, action) {
      state.selectedApplications.push(action.payload);
    },
    removeApplication(state, action) {
      state.selectedApplications = state.selectedApplications.filter(
        (app) => app.id !== action.payload.id
      );
    },
    clearApplications(state) {
      state.selectedApplications = [];
    },
  },
});

export const VdiServiceActions = ResourceAllocationSlice.actions;

const LINK = `${process.env.REACT_APP_API_URL}`;
type CONTEXTID = {
  sub: string;
  contextId: string;
};
export const getParticipants = () => async (dispatch) => {
  try {
    const response = await axios.get(`${LINK}/events/api/v1/participants`);
    if (response?.data?.status) {
      dispatch(
        ResourceAllocationSlice.actions.participants(response.data.data),
      );
      dispatch(vdiserviceslice.actions.setDataNotFound(false));
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getParticipantData = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${LINK}/events/api/v1/participants/playground`,
    );
    if (response?.data?.status) {
      dispatch(
        ResourceAllocationSlice.actions.setLiveParticipants(response.data.data),
      );
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const AssignAllocate = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.AllocateDialog(data));
};

export const SortingParticants = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setSortingParticipants(data));
};

export const VDIOptions = (data) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${LINK}/service-management/api/v1/service`,
      data,
    );

    if (response?.data?.status) {
      dispatch(
        ResourceAllocationSlice.actions.VDIOptions({
          active: true,
          color: "success",
          message: "Operation is successfully",
        }),
      );
    } else {
      dispatch(
        ResourceAllocationSlice.actions.VDIOptions({
          active: true,
          color: "error",
          message: "Operation failed",
        }),
      );
    }
    setTimeout(() => {
      dispatch(
        ResourceAllocationSlice.actions.VDIOptions({
          active: false,
          message: "",
          color: "",
        }),
      );
    }, 3000);
  } catch (error) {
    throw new Error(error);
  }
};

export const showBulkDestroyActiveMachine = (data) => (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.showBulkDestroyActiveMachine(data));
};

export const bulkDestroyMachine = (data, enqueueSnackbar) => async () => {
  try {
    const deleteMachineResponse = await axios.post(
      `${LINK}/service-management/api/v1/service`,
      data,
    );

    if (!deleteMachineResponse?.data?.status) {
      throw new Error(
        deleteMachineResponse?.data?.message || "Machine destroy failed",
      );
    }
  } catch (error) {
    enqueueSnackbar(error?.message || error || "Machine destroy failed", {
      variant: "error",
      preventDuplicate: true,
      autoHideDuration: 5000,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  }
};

export const assignedMachineData = (data) => (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.assignedMachineData(data));
};

export const setSpeakingStatusInParticipants = (data) => (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setSpeakingStatus(data));
};
export const setTrainerSpeakingStatusInParticipants = (data) => (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setTrainerSpeakingStatus(data));
};
export const setUpdateFilterParticipant = (data) => (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setUpdateFilterParticipants(data));
};

export const DeAllocate = (data) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${LINK}/service-management/api/v1/access/revoke-access`,
      data,
    );
    if (response?.data?.status) {
      dispatch(
        ResourceAllocationSlice.actions.VDIOptions({
          active: true,
          color: "success",
          message: response?.data?.data,
        }),
      );
    } else {
      dispatch(
        ResourceAllocationSlice.actions.VDIOptions({
          active: true,
          color: "error",
          message: response?.data?.message,
        }),
      );
    }

    setTimeout(() => {
      dispatch(
        ResourceAllocationSlice.actions.VDIOptions({
          active: false,
          message: "",
          color: "",
        }),
      );
    }, 3000);
  } catch (error) {
    throw new Error(error);
  }
};

export const getAllServices =
  (updateState = false) =>
    async (dispatch) => {
      try {
        const responseservices: any = await axios.get(
          `${LINK}/service-management/api/v1/service`,
        );
        if (
          responseservices?.data?.status &&
          responseservices?.data?.data?.length > 0
        ) {
          dispatch(
            ResourceAllocationSlice.actions.availableservices(
              responseservices?.data?.data,
            ),
          );
          if (!updateState) {
            dispatch(
              ResourceAllocationSlice.actions.storeFilterServiceDevices(
                responseservices?.data?.data,
              ),
            );
            dispatch(
              vdiserviceslice.actions.setSkeleton({
                key: "instance",
                value: false,
              }),
            );
          }
        } else {
          dispatch(ResourceAllocationSlice.actions.availableservices([]));
        }
      } catch (error) {
        throw new Error(error);
      }
    };

export const serviceUpdate = (data) => async (dispatch, getState) => {
  dispatch(
    ResourceAllocationSlice.actions.setServiceUpdate({
      key: data.response.data.serviceId,
      value: data.response.data.state,
    }),
  );

  // If the machine is no longer running and it was being shared, auto-clear sharing state
  const newState = data.response.data.state;
  const serviceId = data.response.data.serviceId;
  if (newState !== "STARTED") {
    const reduxState = getState();
    const vdiInfoRead = reduxState?.editor?.vdiInfoRead;
    if (vdiInfoRead?.device === serviceId) {
      dispatch(removePresenterAccessUpdate());
      dispatch(setSnakMsg(false, { participant_name: "" }));
      const ymapPreference = reduxState?.editor?.ymapPreference;
      if (ymapPreference) {
        ymapPreference.set("present_vdi", {
          ...ymapPreference.get("present_vdi"),
          status: false,
        });
        ymapPreference.set("vdi_sharing_removed", {
          status: true,
          participant_name: "",
          timestamp: Date.now(),
        });
      }
    }

    // Forcefully remove the specific Machine Tab if the machine is dead
    const headerTabs = reduxState?.avToolbar?.headerTabs;
    const dropDownTabs = reduxState?.avToolbar?.dropDownTabs;
    const activeTab = reduxState?.avToolbar?.activeTab;

    // Find if there's a machine tab for this specific serviceId (match by deviceId OR name)
    const { findMachineName, handleCloseMachineTab } = await import("src/constants/commonFuntion");
    const machineName = findMachineName(serviceId);
    const expectedTabName = machineName ? "Machine (" + machineName + ")" : "";

    const isTargetTab = (tab) =>
      tab.type === "Machine" &&
      (tab.deviceId === serviceId || (!tab.deviceId && expectedTabName && tab.name === expectedTabName));

    const matchingHeaderTab = headerTabs?.find(isTargetTab);
    const matchingDropDownTab = dropDownTabs?.find(isTargetTab);

    if (matchingHeaderTab || matchingDropDownTab) {
      const { setActiveTab } = await import("src/slices/AvToolbar");
      const { removeMachineByDeviceId } = await import("src/slices/persistStore");

      handleCloseMachineTab(serviceId);
      dispatch(removeMachineByDeviceId(serviceId));

      const isCurrentActiveTabThisMachine = matchingHeaderTab?.name === activeTab || matchingDropDownTab?.name === activeTab;
      if (isCurrentActiveTabThisMachine) {
        dispatch(setActiveTab("home"));
      }

      const ymapPreference = reduxState?.editor?.ymapPreference;
      if (ymapPreference) {
        const obj = ymapPreference.get("tab");
        if (obj && obj.tabData) {
          const newTabData = obj.tabData.filter((t) =>
            !(t.type === "Machine" && (t.deviceId === serviceId || (!t.deviceId && expectedTabName && t.name === expectedTabName)))
          );
          const newObj = {
            ...obj,
            tabData: newTabData,
            activeTab: isCurrentActiveTabThisMachine ? "home" : obj.activeTab,
          };
          ymapPreference.set("tab", newObj);
        }
      }
    }
  }

  dispatch(getAllServices(true));
  dispatch(getParticipants());
};

export const participantsUpdate = (data) => async (dispatch) => {
  dispatch(
    ResourceAllocationSlice.actions.setParticipantsUpdate({
      key: data.response.data.participant_id,
      value: data.response.data.lock,
    }),
  );
};
export const toggleResourceDrawer = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.toggleDrawer(data));
};

export const fetchingGourpData =
  (data, group = false, groupId = "", hitFirst = false) =>
    async (dispatch) => {
      const config = {
        headers: {
          contextId: data,
        },
      };
      if (group && hitFirst) {
        try {
          const response: any = await axios.get(
            `${LINK}/service-management/api/v1/group`,
            config,
          );
          if (response?.data?.status && response?.data?.data?.length > 0) {
            dispatch(
              ResourceAllocationSlice.actions.availableGroups(
                response?.data?.data,
              ),
            );
            dispatch(
              vdiserviceslice.actions.setSkeleton({ key: "group", value: false }),
            );
            if (groupId) {
              const responseservices: any = await axios.get(
                `${LINK}/service-management/api/v1/service?groupId=${groupId}`,
              );
              dispatch(
                ResourceAllocationSlice.actions.storeServiceDevice(
                  responseservices?.data?.data,
                ),
              );
              dispatch(storeCurrentGroupID(groupId));
            } else {
              const responseservices: any = await axios.get(
                `${LINK}/service-management/api/v1/service?groupId=${response?.data?.data[0].id}`,
              );
              dispatch(
                ResourceAllocationSlice.actions.storeServiceDevice(
                  responseservices?.data?.data,
                ),
              );
              dispatch(storeCurrentGroupID(response?.data?.data[0]?.id));
            }
          }
        } catch (error) {
          throw new Error(error);
        }
      }
    };

export const fetcingLiveServices = (data, groupId) => async (dispatch) => {
  if (data?.response?.data?.group_id) {
    const config = {
      headers: {
        contextId: window.location.href.split("/")[4],
      },
    };
    try {
      const response: any = await axios.get(
        `${LINK}/service-management/api/v1/group`,
        config,
      );
      dispatch(
        ResourceAllocationSlice.actions.availableGroups(response?.data?.data),
      );
      if (groupId === data.response?.data?.group_id) {
        const responseservices: any = await axios.get(
          `${LINK}/service-management/api/v1/service?groupId=${data?.response?.data?.group_id}`,
        );
        if (responseservices?.data?.status) {
          dispatch(
            ResourceAllocationSlice.actions.storeServiceDevice(
              responseservices?.data?.data,
            ),
          );
        }
      }
    } catch (error) {
      throw new Error(error);
    }
  }
};

export const getGroupData = (groupId) => async (dispatch) => {
  try {
    const responseservices: any = await axios.get(
      `${LINK}/service-management/api/v1/service?groupId=${groupId}`,
    );

    if (!responseservices?.data?.status) {
      throw new Error(
        responseservices?.data?.message || "Could not fetch group details",
      );
    }

    if (responseservices?.data?.status) {
      dispatch(
        ResourceAllocationSlice.actions.storeServiceDevice(
          responseservices?.data?.data,
        ),
      );
    }
  } catch (error) {
    useSnackbarRef.enqueueSnackbar(
      error?.message || error || "Could not fetch group details",
      {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      },
    );
  }
};

export const fetchApplicationsToInstall = () => async (dispatch) => {
  try {
    dispatch(ResourceAllocationSlice.actions.setApplicationsLoading(true));
    const response = await axios.get(
      `${LINK}/ai-services/api/v1/server?type=linux_application`
    );

    const apps = response?.data?.data?.data?.map((item) => ({
      id: item.id,
      itemName: item.app || item.name, // handle inconsistent API
      path: item.url,
    }));

    dispatch(ResourceAllocationSlice.actions.applicationsData(apps));
  } catch (err) {
    dispatch(
      FailureSnackbar({
        message: "Failed to fetch applications",
        open: true,
      })
    );
  } finally {
    dispatch(ResourceAllocationSlice.actions.setApplicationsLoading(false));
  }
};

export const createVdiGroup = (data, enqueueSnackbar) => async (dispatch: any, getState: any) => {
  const { selectedApplications } = getState().resourceAllocation || {};
  const applicationIds = selectedApplications?.map((app) => app.id) || [];
  const group1 =
    data?.customImg === "0" || !data?.customImg
      ? {
        name: data?.name,
        subRecordType: "virtual_desktop_infrastructure_browser",
        properties: {
          instanceCount: Number(data?.instanceCount),
          instantiationType: data?.instantiationType,
        },
        instantiation: {
          type: "absolute",
          time: "2022-02-23T12:44:37.008+00:00",
          offset: 5,
        },
        userData: {
          location: data?.plan?.locations,
          os: data?.plan?.os,
          provider: data?.plan?.provider,
          cpu_count: data?.plan?.properties?.CPU,
          ram: data?.plan?.properties?.RAM,
          ssd: data?.plan?.properties?.HDD,
          planId: data?.plan?.id,
          applications: applicationIds,
        },
      }
      : {
        name: data?.name,
        subRecordType: "virtual_desktop_infrastructure_browser",
        properties: {
          instanceCount: Number(data?.instanceCount),
          instantiationType: data?.instantiationType,
        },
        instantiation: {
          type: "absolute",
          time: "2022-02-23T12:44:37.008+00:00",
          offset: 5,
        },
        userData: {
          location: data?.plan?.locations,
          os: data?.plan?.os,
          provider: data?.plan?.provider,
          cpu_count: data?.plan?.properties?.CPU,
          ram: data?.plan?.properties?.RAM,
          ssd: data?.plan?.properties?.HDD,
          planId: data?.plan?.id,
          applications: applicationIds,
        },
        customImage: {
          id: data?.customImg,
          enabled: true,
        },
      };

  dispatch(
    ResourceAllocationSlice.actions.setSnack({
      active: true,
      color: ECOLOR?.SUCCESS,
      message: "Requesting to create a group",
    }),
  );
  const group = group1;

  const config = {
    headers: {
      contextId: data.contextId,
    },
  };
  try {
    const response = await axios.post(
      `${LINK}/service-management/api/v1/group`,
      group,
      config,
    );
    if (response?.data?.status) {
      dispatch(
        ResourceAllocationSlice.actions.setSnack({
          active: true,
          color: ECOLOR?.SUCCESS,
          message: "Group Created Successfully",
        }),
      );
    } else {
      dispatch(
        ResourceAllocationSlice.actions.setSnack({
          active: true,
          color: ECOLOR?.ERROR,
          message: response?.data?.message,
        }),
      );
    }
    dispatch(handleMyLicenseApi(enqueueSnackbar));
    setTimeout(() => {
      dispatch(
        ResourceAllocationSlice.actions.setSnack({
          active: false,
          color: ECOLOR?.SUCCESS,
          message: "",
        }),
      );
    }, 3000);
  } catch (error) {
    throw new Error(error);
  }
};

export const updatePlanVDI =
  (data, groupId, allowedPermissions) => async (dispatch) => {
    const body = {
      location: data?.location,
      os: data?.os,
      provider: data?.provider,
      cpu_count: data?.plan?.properties?.CPU,
      ram: data?.plan?.properties?.RAM,
      ssd: data?.plan?.properties?.HDD,
      planId: data?.plan?.id,
    };

    const config = {
      headers: {
        contextId: data?.contextId,
      },
    };

    try {
      const response = await axios.put(
        `${LINK}/service-management/api/v1/group/${groupId}/userdata`,
        body,
        config,
      );

      if (response?.data?.status) {
        dispatch(
          ResourceAllocationSlice.actions.setSnack({
            active: true,
            color: ECOLOR?.SUCCESS,
            message: "Group Upgraded",
          }),
        );
        const CONTEXTID: CONTEXTID = jwt_decode(localStorage.getItem("token"));
        dispatch(
          fetchingGourpData(
            CONTEXTID.contextId,
            allowedPermissions?.includes(Permission?.VIEW_GROUP),
            "",
            true,
          ),
        );
      }
      setTimeout(() => {
        dispatch(
          ResourceAllocationSlice.actions.setSnack({
            active: false,
            color: ECOLOR?.SUCCESS,
            message: "",
          }),
        );
      }, 3000);
    } catch (error) {
      throw new Error(error);
    }
  };

export const IncreaseInstance =
  (contextId, groupId, count, MachineCount, enqueueSnackbar) =>
    async (dispatch) => {
      dispatch(
        ResourceAllocationSlice.actions.setSnack({
          active: true,
          color: ECOLOR?.SUCCESS,
          message: `Requesting for machine PC-${MachineCount + 1} `,
        }),
      );

      setTimeout(() => {
        dispatch(
          ResourceAllocationSlice.actions.setSnack({
            active: false,
            color: ECOLOR?.SUCCESS,
            message: "",
          }),
        );
      }, 3000);

      const config = {
        headers: {
          contextId: contextId,
        },
      };
      const body = {
        instanceCount: count + 1,
      };
      try {
        const response = await axios.put(
          `${LINK}/service-management/api/v1/group/${groupId}/properties`,
          body,
          config,
        );
        if (response?.data?.status) {
          dispatch(
            ResourceAllocationSlice.actions.setSnack({
              active: true,
              color: ECOLOR?.SUCCESS,
              message: `Machine PC-${MachineCount + 1} Added`,
            }),
          );
        }
        dispatch(handleMyLicenseApi(enqueueSnackbar));
        setTimeout(() => {
          dispatch(
            ResourceAllocationSlice.actions.setSnack({
              active: false,
              color: ECOLOR?.SUCCESS,
              message: "",
            }),
          );
        }, 3000);
      } catch (error) {
        throw new Error(error);
      }
    };

export const AssignInstance =
  (
    particiapntId,
    serviceId,
    groupId,
    action,
    deviceId,
    StoPActive,
    PtoSActive,
    ASSIGN_SERVICE,
    REVOKE_SERVICE,
  ) =>
    async (dispatch) => {
      const body = {
        device: serviceId,
        access: "owner",
      };
      dispatch(ResourceAllocationSlice.actions.setDeviceAssignLoader(true));
      try {
        if (action === "StoP" && PtoSActive && ASSIGN_SERVICE) {
          const response = await axios.put(
            `${LINK}/events/api/v1/participants/${particiapntId}/deviceAssign`,
            [body],
          );

          if (response?.data?.status) {
            if (response?.data?.data?.find((value) => value?.status === false)) {
              dispatch(
                ResourceAllocationSlice.actions.setSnack({
                  active: true,
                  color: ECOLOR?.SUCCESS,
                  message: response?.data?.data?.find(
                    (value) => value?.status === false,
                  ).message,
                }),
              );
              setTimeout(() => {
                dispatch(
                  ResourceAllocationSlice.actions.setSnack({
                    active: false,
                    color: ECOLOR?.SUCCESS,
                    message: "",
                  }),
                );
              }, 3000);
            }
          } else {
            dispatch(
              ResourceAllocationSlice.actions.setSnack({
                active: true,
                color: ECOLOR?.ERROR,
                message: response?.data?.message,
              }),
            );
            setTimeout(() => {
              dispatch(
                ResourceAllocationSlice.actions.setSnack({
                  active: false,
                  color: ECOLOR?.SUCCESS,
                  message: "",
                }),
              );
            }, 3000);
          }
        } else if (action === "PtoS" && StoPActive && REVOKE_SERVICE) {
          const data = {
            active: true,
            body: {
              device: deviceId,
              participant_id: particiapntId,
              access: "owner",
            },
            groupId,
          };

          dispatch(ResourceAllocationSlice.actions.setPropmtData(data));
        } else if (action === "PtoS" && PtoSActive && ASSIGN_SERVICE) {
          const body = {
            device: deviceId,
            access: "owner",
          };
          const response = await axios.put(
            `${LINK}/events/api/v1/participants/${particiapntId}/deviceAssign`,
            [body],
          );

          if (response?.data?.status) {
            const errorValue = response?.data?.data?.find(
              (value) => value?.status === false,
            );
            if (errorValue) {
              dispatch(
                ResourceAllocationSlice.actions.setSnack({
                  active: true,
                  color: ECOLOR?.SUCCESS,
                  message: errorValue?.message,
                }),
              );
            }
          } else {
            dispatch(
              ResourceAllocationSlice.actions.setSnack({
                active: true,
                color: ECOLOR?.ERROR,
                message: response?.data?.message,
              }),
            );
            setTimeout(() => {
              dispatch(
                ResourceAllocationSlice.actions.setSnack({
                  active: false,
                  color: ECOLOR?.SUCCESS,
                  message: "",
                }),
              );
            }, 3000);
          }
        }
        dispatch(StoPStateChange(false));
        dispatch(PtoSStateChange(false));
      } catch (error) {
        throw new Error(error);
      } finally {
        dispatch(ResourceAllocationSlice.actions.setDeviceAssignLoader(false));
      }
    };

export const AllocateAssign =
  (participantId, data) => async (dispatch) => {
    dispatch(ResourceAllocationSlice.actions.setDeviceAssignLoader(true));
    try {
      const response = await axios.put(
        `${LINK}/events/api/v1/participants/${participantId}/deviceAssign`,
        data,
      );
      if (response?.data?.status) {
        if (response?.data?.data?.find((value) => value?.status === false)) {
          dispatch(
            ResourceAllocationSlice.actions.setSnack({
              active: true,
              color: ECOLOR?.SUCCESS,
              message: response?.data?.data?.find(
                (value) => value?.status === false,
              ).message,
            }),
          );
          setTimeout(() => {
            dispatch(
              ResourceAllocationSlice.actions.setSnack({
                active: false,
                color: ECOLOR?.SUCCESS,
                message: "",
              }),
            );
          }, 3000);
        } else {
          dispatch(
            ResourceAllocationSlice.actions.setSnack({
              active: true,
              color: ECOLOR?.SUCCESS,
              message: "Instance Assigned",
            }),
          );
          setTimeout(() => {
            dispatch(
              ResourceAllocationSlice.actions.setSnack({
                active: false,
                color: ECOLOR?.SUCCESS,
                message: "",
              }),
            );
          }, 3000);
        }
      } else {
        dispatch(
          ResourceAllocationSlice.actions.setSnack({
            active: true,
            color: ECOLOR?.ERROR,
            message: response?.data?.message,
          }),
        );
        setTimeout(() => {
          dispatch(
            ResourceAllocationSlice.actions.setSnack({
              active: false,
              color: ECOLOR?.SUCCESS,
              message: "",
            }),
          );
        }, 3000);
      }
    } catch (error) {
      throw new Error(error);
    } finally {
      dispatch(ResourceAllocationSlice.actions.setDeviceAssignLoader(false));
    }
  };

export const BulkAllocateAssign =
  (participants, devices) => async (dispatch) => {
    dispatch(ResourceAllocationSlice.actions.setDeviceAssignLoader(true));
    try {
      const data = {
        participants: participants,
        devices: devices,
      };
      const response = await axios.put(
        `${LINK}/events/api/v1/participants/deviceAssign`,
        data,
      );
      if (response?.data?.status) {
        setTimeout(() => {
          dispatch(
            ResourceAllocationSlice.actions.setSnack({
              active: false,
              color: ECOLOR?.SUCCESS,
              message: "",
            }),
          );
        }, 3000);
      } else {
        dispatch(
          ResourceAllocationSlice.actions.setSnack({
            active: true,
            color: ECOLOR?.ERROR,
            message: response?.data?.message || "Assignment Failed",
          }),
        );
        setTimeout(() => {
          dispatch(
            ResourceAllocationSlice.actions.setSnack({
              active: false,
              color: ECOLOR?.SUCCESS,
              message: "",
            }),
          );
        }, 3000);
      }
    } catch (error) {
      dispatch(
        ResourceAllocationSlice.actions.setSnack({
          active: true,
          color: ECOLOR?.ERROR,
          message: error.message || "Something went wrong",
        }),
      );
    } finally {
      dispatch(ResourceAllocationSlice.actions.setDeviceAssignLoader(false));
    }
  };

export const revokeAPIconfirmationAccept = (data) => async (dispatch, getState) => {
  try {
    const presenterDevice = getState()?.editor?.vdiInfoRead?.device;
    if (presenterDevice && presenterDevice === data?.body?.device) {
      dispatch(editorActions.setIsStoppingPresenter(true));
      await dispatch(removePresenterAccess(presenterDevice));
    }

    const response = await axios.put(
      `${LINK}/service-management/api/v1/access/revoke-access`,
      data.body,
    );

    if (response?.data?.status) {
      dispatch(
        ResourceAllocationSlice.actions.setPropmtData({ active: false }),
      );
      setTimeout(() => {
        dispatch(
          ResourceAllocationSlice.actions.setSnack({
            active: false,
            color: ECOLOR?.SUCCESS,
            message: "",
          }),
        );
      }, 3000);
    }
    dispatch(StoPStateChange(false));
    dispatch(PtoSStateChange(false));
  } catch (error) {
    throw new Error(error);
  }
};

export const revokeAPIconfirmationCancel = () => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setPropmtData({ active: false }));

  dispatch(StoPStateChange(false));
  dispatch(PtoSStateChange(false));
};

export const setSnackValue = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setSnack(data));
};

export const fetchingServicesDevices = (data) => async (dispatch) => {
  try {
    dispatch(storeCurrentGroupID(data));
    const response = await axios.get(
      `${LINK}/service-management/api/v1/service?groupId=${data}`,
    );
    dispatch(
      ResourceAllocationSlice.actions.storeServiceDevice(response?.data?.data),
    );
  } catch (error) {
    throw new Error(error);
  }
};

export const setParticiapntID = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setParticiapntId(data));
};

export const setServicesID = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setServiceId(data));
};

export const setMoveAction = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setAction(data));
};

export const deviceID = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setDeviceId(data));
};
export const PtoSStateChange = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setPtoSActive(data));
};

export const participantsIsLocked = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setLocked(data));
};

export const lockedMsg = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setLockedMsg(data));
};

export const StoPStateChange = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setStoPActive(data));
};

export const storeFilterValue = (value) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setFilterValue(value));
};

export const setCurrentPageNumber = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setCurrentPage(data));
};

export const storeParticipantsDataFilter = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setParticipantData(data));
};

export const groupUpdatedNotification = () => async (dispatch) => {
  dispatch(
    ResourceAllocationSlice.actions.setUpdateGroupSnack({
      active: true,
      message: "Group Updating",
    }),
  );
  setTimeout(() => {
    dispatch(
      ResourceAllocationSlice.actions.setUpdateGroupSnack({
        active: false,
        message: "",
      }),
    );
  }, 3000);
};

export const dispatchUserTablePage = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setUserTablePage(data));
};

export const UpdateGroupVdiGroup = (data) => async (dispatch) => {
  const contextId = window.location.href.split("/")[4];
  const config = {
    headers: {
      contextId: contextId,
    },
  };
  try {
    const response: any = await axios.get(
      `${LINK}/service-management/api/v1/group`,
      config,
    );
    dispatch(
      ResourceAllocationSlice.actions.availableGroups(response?.data?.data),
    );
    dispatch(storeCurrentGroupID(data.response?.data?.group_id));
    dispatch(setCurrentPageNumber(response?.data?.data?.length));
    if (response?.data?.status) {
      const responseservices = await axios.get(
        `${LINK}/service-management/api/v1/service?groupId=${data.response?.data?.group_id}`,
      );
      const responseservicesUpdate: any = await axios.get(
        `${LINK}/service-management/api/v1/service`,
      );
      if (responseservicesUpdate?.data?.status) {
        dispatch(
          ResourceAllocationSlice.actions.availableservices(
            responseservicesUpdate?.data?.data,
          ),
        );
      }
      dispatch(
        ResourceAllocationSlice.actions.storeServiceDevice(
          responseservices?.data?.data,
        ),
      );
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const UpdateGroupVdiGroupStatus = () => async (dispatch) => {
  try {
    const contextId = window.location.href.split("/")[4];
    const config = {
      headers: {
        contextId: contextId,
      },
    };
    const response: any = await axios.get(
      `${LINK}/service-management/api/v1/group`,
      config,
    );
    dispatch(
      ResourceAllocationSlice.actions.availableGroups(response?.data?.data),
    );
  } catch (error) {
    throw new Error(error);
  }
};

export const setDeallocateMultiple = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setDeallocateAll(data));
};

export const setMachineOperation = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setOperationMachine(data));
};

export const destroyMessageConfrimation = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setDestroyMessage(data));
};

export const DestroyConfrimationClear = () => async (dispatch: any) => {
  dispatch(ResourceAllocationSlice.actions.setDestroyMessageClear());
};
export const MachineOperationClear = () => async (dispatch: any) => {
  dispatch(ResourceAllocationSlice.actions.setOperationMachineClear());
};

export const handleMachineStopNotification = (data) => () => {
  if (data.state === "STOPPING" || data.state === "STOPPED") {
    useSnackbarRef.enqueueSnackbar(
      `${data.state.charAt(0)?.toUpperCase()}${data.state
        .toLowerCase()
        .slice(1)} ${data.serviceName}`,
      {
        variant: data.state === "STOPPING" ? "warning" : "success",
        autoHideDuration: 5000,
      },
    );
  } else if (data.message === "Performing delete on VDI") {
    useSnackbarRef.enqueueSnackbar(`${data.message} ${data.serviceName}`, {
      variant: "success",
      autoHideDuration: 5000,
    });
  }
};

export const CurrentTabOpened = (data) => async (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.setCurrentTabOpened(data));
};

export const handleShowMaxLimitDisclaimer = (data) => (dispatch) => {
  dispatch(ResourceAllocationSlice.actions.handleShowMaxLimitDisclaimer(data));
};

export const handleMyLicenseApi = (enqueueSnackbar) => async () => {
  try {
    const getLicenseResponse = await axios.get(`${LINK}/aacl/api/v1/license`);

    if (!getLicenseResponse?.data?.status) {
      throw new Error(
        getLicenseResponse?.data?.message || "Could not fetch license details",
      );
    }

  } catch (error) {
    enqueueSnackbar(
      error?.message || error || "Could not fetch license details",
      {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 5000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      },
    );
  }
};

export const getArchivalCostAPI =
  (data, enqueueSnackbar) => async (dispatch) => {
    try {
      const loader = {
        key: "planLoader",
        value: true,
      };
      dispatch(ResourceAllocationSlice.actions.machineArchival(loader));
      const response = await axios.get(
        `${LINK}/service-management/api/v1/cloud/plans?id=${data?.planId}`,
      );
      if (response?.status === 200 && response?.data?.status) {
        const archivalCostPerhour = {
          key: "archivalCostPerHour",
          value:
            response?.data?.data[0]?.properties?.archivalCostPerHour?.toFixed(
              4,
            ),
        };
        const monthlyHours = {
          key: "monthlyHours",
          value: response?.data?.data[0]?.properties?.monthlyHours,
        };
        dispatch(
          ResourceAllocationSlice.actions.machineArchival(archivalCostPerhour),
        );
        dispatch(ResourceAllocationSlice.actions.machineArchival(monthlyHours));
      } else {
        throw new Error(
          response?.data?.message || "Failed to fetch archival cost",
        );
      }
    } catch (error) {
      enqueueSnackbar(
        error?.message || error || "Failed to fetch archival cost",
        {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 5000,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        },
      );
    } finally {
      const loader = {
        key: "planLoader",
        value: false,
      };
      dispatch(ResourceAllocationSlice.actions.machineArchival(loader));
    }
  };

export const renameVDI = (id: string, name: string) => async (dispatch) => {
  try {
    const response = await axios.patch(
      `${LINK}/service-management/api/v1/service/${id}`,
      { name }
    );
    if (response?.data?.status) {
      dispatch(ResourceAllocationSlice.actions.updateServiceName({ id, name }));
      return true;
    } else {
      return false;
    }
  } catch (error) {
    dispatch(
      ResourceAllocationSlice.actions.setSnack({
        active: true,
        color: ECOLOR.ERROR,
        message: error?.message || "Something went wrong",
      }),
    );
    return false;
  }
};

export const reducer = ResourceAllocationSlice;

export default ResourceAllocationSlice;
